import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from './../../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class BusinessService {
  public gouvernorats = [
    {
      division: 'Ariana',
      subDivisions: [
        'Ariana Medina',
        'Ettadhamen',
        ' Kalaat El Andalous',
        'Mnihla',
        'Raoued',
        'Sidi Thabet',
        'Soukra',
      ],
    },
    {
      division: 'Béja',
      subDivisions: [
        'Amdoun',
        'Beja North',
        'Beja South',
        'Goubellat',
        'Mejez El Bab',
        'Nefza',
        'Teboursouk',
        'Testour',
        'Thibar',
      ],
    },
    {
      division: 'Ben Arous',
      subDivisions: [
        'Ben Arous',
        'Boumhel',
        'El Mourouj',
        'Ezzahra',
        'Fouchana',
        'Hammam Chott',
        'Hammam-Lif',
        "M'Hamdia",
        'Medina Jedida',
        'Mégrine',
        'Mornag',
        'Rades',
        'Yasminet',
        'Azur City ',
        'Marché Gros',
        'Mghira',
        'Borj Cédria',
        'boukornine',
        'Bir El Bey',
        'Cité Olympique Rades',
        'Chouchet Rades',
        'El moujrouj 1.2.3.4.5.6',
        'Sidi Rezig',
        'Boujardga',
        'Naaseen',
        'Chbéda',
        'Khalidia',
        'Douar el Houch',
        'Mallassine',
        'Hay Hlel',
        '13 Aout',
        'El Kabaria',
        'Ibn Sina',
        'El Ouardia',
        'Jebel Jelloud',
        'la cagna (lakania)',
        'Seydi Ali Reis',
        'El Nesri',
        'Hay el baladi',
      ],
    },
    {
      division: 'Bizerte',
      subDivisions: [
        'Bizerte North',
        'Bizerte South',
        'Djoumime',
        'El Alia',
        'Ghar El Melh',
        'Ghezala',
        'Mateur',
        'Menzel Bourguiba',
        'Menzel Jemil',
        ' Ras Jebel',
        'Sejenane',
        'Tinja',
        'Utique',
        'Zarzouna',
      ],
    },
    {
      division: 'Gabès',
      subDivisions: [
        'Gabes Medina',
        'Gabes West',
        'Gabes South',
        'Ghannouch',
        'Hamma',
        'Mareth',
        'Matmata',
        'New Matmata',
        'Menzel Habib',
        'Metouia',
      ],
    },
    {
      division: 'Gafsa',
      subDivisions: [
        'Gabes Medina',
        'Gabes West',
        'Gabes South',
        'Ghannouch',
        'Hamma',
        'Mareth',
        'Matmata',
        'New Matmata',
        'Menzel Habib',
        'Metouia',
      ],
    },
    {
      division: 'Jendouba',
      subDivisions: [
        'Aïn Draham',
        'Balta',
        'Bousalem',
        'Fernana',
        'Ghardimaou',
        'Jendouba',
        'Jendouba Nord',
        'Oued Mliz',
        'Tabarka',
      ],
    },
    {
      division: 'Kairouan',
      subDivisions: [
        'Alaa',
        'Bouhajla',
        'Chebika',
        'Chrarda',
        'Haffouz',
        'Hajeb El Ayoun',
        'Kairouan North',
        'Kairouan South',
        'Nasrallah',
        'Oueslatia',
        'Sbikha',
      ],
    },
    {
      division: 'Kasserine',
      subDivisions: [
        'Ayoun',
        'Ezzouhour',
        'Feriana',
        'Foussana',
        'Hassi El Ferid',
        'Hidra',
        'Jedeliane',
        'Kasserine North',
        'Kasserine South',
        'Majel Belabbes',
        'Sbeitla',
        'Sbiba',
        'Thala',
      ],
    },
    {
      division: 'Kebili',
      subDivisions: [
        'Douz North',
        'Douz South',
        'Faouar',
        'Kebili North',
        'Kebili South',
        'Souk El Ahed',
      ],
    },
    {
      division: 'Kef',
      subDivisions: [
        'Dahmani',
        'Es Sers',
        'Jerissa',
        'Kalaa Khasbat',
        'Kalaat Senane',
        'Kef East',
        'Kef West',
        'Ksour',
        'Nebeur',
        'Sakiet Sidi Youssef',
        'Tajerouine',
      ],
    },
    {
      division: 'Mahdia',
      subDivisions: [
        'Boumerdes',
        'Chebba',
        'Chorbane',
        'El Djem',
        'Hbira',
        'Ksour Essef',
        'Mahdia',
        'Melloulech',
        'Ouled Chamekh',
        'Sidi Alouane',
        'Souassi',
      ],
    },
    {
      division: 'Manouba',
      subDivisions: [
        'Borj El Amri',
        'Douar Hicher',
        'El Battan',
        'Jedaida',
        'Manouba',
        'Mornaguia',
        'Oued Ellil',
        'Tebourba',
      ],
    },
    {
      division: 'Medenine',
      subDivisions: [
        'Ben Guerdane',
        'Beni Khedache',
        'Djerba Ajim',
        'Djerba Midoun',
        'Djerba Houmt Souk',
        'Medenine North',
        'Medenine South',
        'Sidi Makhlouf',
        'Zarzis',
      ],
    },
    {
      division: 'Monastir',
      subDivisions: [
        'Bekalta',
        'Bembla',
        'Beni Hassen',
        'Jammel',
        'Ksar Hellal',
        'Ksibet El Mediouni',
        'Moknine',
        'Monastir',
        'Ouerdanine',
        'Sahline',
        'Sayada-Lamta-Bou Hjar',
        'Teboulba',
        'Zeramdine',
      ],
    },
    {
      division: 'Nabeul',
      subDivisions: [
        'Beni Khalled',
        'Beni Khiar',
        'Bou Argoub',
        'Dar Chaabane El Fehri',
        'El Mida',
        'Grombalia',
        'Hammam Ghezaz',
        'Hammamet',
        'Haouaria',
        'Kelibia',
        'Korba',
        'Menzel Bouzelfa',
        'Menzel Temime',
        'Nabeul',
        'Soliman',
        'Takelsa',
      ],
    },
    {
      division: 'Sfax',
      subDivisions: [
        'Agareb',
        'Bir Ali Ben Khelifa',
        'El Amra',
        'El Ghraiba',
        'Hencha',
        'Jebeniana',
        'Kerkennah',
        'Mahres',
        'Menzel Chaker',
        'Sakiet Eddaier',
        'Sakiet Ezzit',
        'Sfax Medina',
        'Sfax West',
        'Sfax South',
        'Skhira',
        'Thyna',
      ],
    },
    {
      division: 'Sidi Bouzid',
      subDivisions: [
        'Bir El Hfay',
        'Jelma',
        'Mazzouna',
        'Meknassi',
        'Menzel Bouzaiene',
        'Ouled Haffouz',
        'Regueb',
        'Sabalat Ouled Asker',
        'Sidi Ali Ben Aoun',
        'Sidi Bouzid East',
        'Sidi Bouzid West',
        'Souk Jedid',
      ],
    },
    {
      division: 'Siliana',
      subDivisions: [
        'Bargou',
        'Bouarada',
        'El Aroussa',
        'El Krib',
        'Gaafour',
        'Kesra',
        'Makthar',
        'Rouhia',
        'Sidi Bourouis',
        'Siliana North',
        'Siliana South',
      ],
    },
    {
      division: 'Sousse',
      subDivisions: [
        'Akouda',
        'Bouficha',
        'Enfidha',
        'Hammam Sousse',
        'Hergla',
        'Kalaa Kebira',
        'Kalaa Sghira',
        'Kondar',
        "M'Saken",
        'Sidi Bou Ali',
        'Sidi El Heni',
        'Sousse Jaouhara',
        'Sousse Medina',
        'Sousse Riadh',
        'Sousse Sidi Abdelhamid',
        'Zaouia Ksiba Thrayat',
      ],
    },
    {
      division: 'Tataouine',
      subDivisions: [
        'Bir Lahmar',
        'Dhiba',
        'Ghomrassen',
        'Remada',
        'Samar',
        'Tataouine North',
        'Tataouine South',
      ],
    },
    {
      division: 'Tozeur',
      subDivisions: ['Degueche', 'Hazoua', 'Nefta', 'Tamaghza', 'Tozeur'],
    },
    {
      division: 'Tunis',
      subDivisions: [
        'Bab Bhar',
        'Bab Souika',
        'Bardo',
        'Bouhaira',
        'Carthage',
        'El Khadra',
        'El Menzah',
        // 'El Ouardia',
        'El Tahrir',
        'Ezzouhour',
        'Hrairia',
        // 'Jebel Jelloud',
        // 'Kabaria',
        'La Goulette',
        'La Marsa',
        'Le Kram',
        'Medina',
        'Omrane',
        'Omrane Superieur',
        'Sidi El Bechir',
        'Sidi Hassine',
        'Sijoumi',
      ],
    },
    {
      division: 'Zaghouan',
      subDivisions: [
        'Bir Mchergua',
        'Fahs',
        'Nadhour',
        'Saouaf',
        'Zaghouan',
        'Zriba',
      ],
    },
  ];
  

  jobToExchange = undefined;

  constructor(private httpClient: HttpClient) {
    this.sortGouvernorats();
  }

  private sortGouvernorats() {
    this.gouvernorats.sort((a, b) => a.division.localeCompare(b.division));
    this.gouvernorats.forEach(gouvernorat => {
      gouvernorat.subDivisions.sort((a, b) => a.localeCompare(b));
    });
  }

  // Start Refactoring

  getBusinesses(params): any {
    return this.httpClient
      .get(environment.api.user + '/businesses', { params })
      .toPromise();
  }

  editBusiness(id, payload): any {
    return this.httpClient
      .put(environment.api.user + '/businesses/' + id, payload)
      .toPromise();
  }

  async getAllBusinessesNames(): Promise<any[]> {
    const response = await this.httpClient
      .get<any[]>(environment.api.user + '/businesses/names')
      .toPromise();
  
    return response.sort((a, b) => {
      const nameA = a.nomCommercial || ''; 
      const nameB = b.nomCommercial || ''; 
      return nameA.localeCompare(nameB);
    });
  }
  
  
  

  // End Refactoring

  resendRequest(data): any {
    return this.httpClient
      .post(
        environment.api.partnerMicroService + '/deliveryrequest/partner/resend',
        data
      )
      .toPromise();
  }
  recoverRequest(data): any {
    return this.httpClient
      .post(
        environment.api.partnerMicroService +
          '/deliveryrequest/partner/recover',
        data
      )
      .toPromise();
  }

  addDeliveryRequest(deliveryRequest): any {
    return this.httpClient
      .post(
        environment.api.partnerMicroService + '/deliveryRequest',
        deliveryRequest
      )
      .toPromise()
      .catch(this.handleError);
  }
  addBusiness(business): any {
    return this.httpClient
      .post(environment.api.partnerMicroService + '/business', business)
      .toPromise()
      .catch(this.handleError);
  }
  addPointRelais(point): any {
    return this.httpClient
      .post(environment.api.partnerMicroService + '/pointRelais', point)
      .toPromise();
  }
  generateDriverHTMLPDF(query): any {
    return this.httpClient
      .post(
        environment.api.partnerMicroService + '/generateDriverRunSheet',
        query,
        {
          observe: 'response',
          responseType: 'arraybuffer',
        }
      )
      .toPromise();
  }

  addExpressDeliveryRequest(deliveryRequest): any {
    return this.httpClient
      .post(
        environment.api.partnerMicroService + '/deliveryRequest' + '/express',
        deliveryRequest
      )
      .toPromise()
      .catch(this.handleError);
  }

  addconciergerieRequest(conciergerieRequest): any {
    return this.httpClient
      .post(
        environment.api.partnerMicroService + '/conciergerieRequest',
        conciergerieRequest
      )
      .toPromise();
  }
  updateDeliveryJobStatus(id, status): any {
    return this.httpClient
      .put(
        environment.api.partnerMicroService +
          '/deliveryRequest' +
          '/updateStatus/' +
          id,
        { status }
      )
      .toPromise();
  }

  deleteJob(body): any {
    return this.httpClient
      .post(environment.api.partnerMicroService + '/packingslip/delete', body)
      .toPromise();
  }
  editPack(body): any {
    return this.httpClient
      .put(environment.api.partnerMicroService + '/packingSlip', body)
      .toPromise();
  }

  getMyPickupsByDriver(body): any {
    return this.httpClient
      .post(
        environment.api.partnerMicroService +
          '/deliveryRequest' +
          '/generatePickupGroupByPartner',
        body
      )
      .toPromise();
  }

  getMyPickUpPoints(query): any {
    var skip = 0;
    var limit = 5;
    return this.httpClient
      .get(
        environment.api.partnerMicroService +
          '/pickup' +
          '?sort=-createdAt' +
          '&query=' +
          query +
          '&skip=' +
          skip +
          '&limit=' +
          limit
      )
      .toPromise()
      .catch(this.handleError);
  }

  getMyLastPickUpInfo(): any {
    return this.httpClient
      .get(
        environment.api.partnerMicroService +
          '/deliveryRequest' +
          '/getLastPartnerPickUpInfo'
      )
      .toPromise();
  }

  getAllDrivers(s = null): any {
    return this.httpClient
      .get(environment.api.user + '/alldrivers/' + s)
      .toPromise();
  }
  getMyDrivers(): any {
    return this.httpClient
      .get(
        environment.api.partnerMicroService + '/packingSlip' + '/getMyDrivers'
      )
      .toPromise();
  }

  getAllTheDeliveryRequest(query, populate, page): any {
    var skip = (page - 1) * 10;
    var limit = 10;
    return this.httpClient
      .get(
        environment.api.partnerMicroService +
          '/deliveryRequest' +
          '?sort=-createdAt' +
          '&populate=' +
          populate +
          '&query=' +
          query +
          '&skip=' +
          skip +
          '&limit=' +
          limit,
        { observe: 'response' }
      )
      .toPromise();
  }
  getAllThePointRelais(query, populate, page): any {
    var skip = (page - 1) * 10;
    var limit = 10;
    return this.httpClient
      .get(
        environment.api.partnerMicroService +
          '/pointRelais' +
          '?sort=-createdAt' +
          '&populate=' +
          populate +
          '&query=' +
          query +
          '&skip=' +
          skip +
          '&limit=' +
          limit,
        { observe: 'response' }
      )
      .toPromise();
  }
  getAllTheConciergerieRequest4Client(query, populate, page): any {
    var skip = (page - 1) * 10;
    var limit = 10;
    return this.httpClient
      .get(
        environment.api.partnerMicroService +
          '/deliveryRequest' +
          '?sort=-createdAt&query=' +
          JSON.stringify(query) +
          '&populate=' +
          populate +
          '&skip=' +
          skip +
          '&limit=' +
          limit,
        { observe: 'response' }
      )
      .toPromise()
      .catch(this.handleError);
  }
  getAllpackingSlip(query, populate, page): any {
    var skip = (page - 1) * 10;
    var limit = 10;
    return this.httpClient
      .get(
        environment.api.partnerMicroService +
          '/packingSlip' +
          '?sort=-updatedAt&query=' +
          query +
          '&populate=' +
          populate +
          '&skip=' +
          skip +
          '&limit=' +
          limit,
        { observe: 'response' }
      )
      .toPromise();
  }

  getAllpackingSlip4Partner(query, populate, page, itemsPerPage): any {
    var skip = (page - 1) * itemsPerPage;
    var limit = itemsPerPage;
    return this.httpClient
      .get(
        environment.api.partnerMicroService +
          '/packingSlip' +
          '?sort=-updatedAt&query=' +
          query +
          '&populate=' +
          populate +
          '&skip=' +
          skip +
          '&limit=' +
          limit,
        { observe: 'response' }
      )
      .toPromise();
  }

  generateMultipleBorderaux4partner(query): any {
    return this.httpClient
      .post(environment.api.partnerMicroService + '/bordereau', query, {
        observe: 'response',
        responseType: 'arraybuffer',
      })
      .toPromise();
  }

  filterAllpackingSlipOld(reqBody): any {
    return this.httpClient
      .post(environment.api.partnerMicroService + '/packingSlip', reqBody)
      .toPromise();
  }

  filterAllpackingSlip(reqBody): any {
    return this.httpClient
      .post(environment.api.partnerMicroService + '/packingSlip/v2', reqBody)
      .toPromise();
  }

  getALlToFixDeliveries(reqBody): any {
    return this.httpClient
      .post(
        environment.api.serverUrl + '/packingSlip' + '/dataToClean',
        reqBody
      )
      .toPromise();
  }
  getSearchMyClients(searchQuery): any {
    return this.httpClient
      .post(
        environment.api.partnerMicroService + '/packingSlip' + '/getMyClients',
        searchQuery
      )
      .toPromise();
  }

  cancelDelivery(reqBody): any {
    return this.httpClient
      .put(environment.api.serverUrl + '/packingSlip' + '/cancel', reqBody)
      .toPromise();
  }

  getStats(): any {
    if (
      localStorage.getItem('connectedAdmin') &&
      JSON.parse(localStorage.getItem('connectedAdmin')).user.business
    ) {
      return this.httpClient
        .get(
          environment.api.partnerMicroService +
            '/stats/client' +
            '?businessId=' +
            JSON.parse(localStorage.getItem('connectedAdmin')).user.business
        )
        .toPromise();
    }
  }

  getHowMuchMoneyIOweIntigo(): any {
    if (
      localStorage.getItem('connectedAdmin') &&
      JSON.parse(localStorage.getItem('connectedAdmin')).user.business
    ) {
      return this.httpClient
        .get(
          environment.api.partnerMicroService +
            '/deliveryrequest/partnerMoney/' +
            JSON.parse(localStorage.getItem('connectedAdmin')).user.business
        )
        .toPromise();
    }
  }

  requestPaymentNowDetails(query): any {
    if (
      localStorage.getItem('connectedAdmin') &&
      JSON.parse(localStorage.getItem('connectedAdmin')).user.business
    ) {
      return this.httpClient
        .post(
          environment.api.partnerMicroService +
            '/deliveryrequest/paymentRequest/' +
            JSON.parse(localStorage.getItem('connectedAdmin')).user.business,
          query
        )
        .toPromise();
    }
  }
  requestPayment(query): any {
    if (
      localStorage.getItem('connectedAdmin') &&
      JSON.parse(localStorage.getItem('connectedAdmin')).user.business
    ) {
      return this.httpClient
        .post(
          environment.api.partnerMicroService +
            '/deliveryrequest/newPaymentRequest',
          query
        )
        .toPromise();
    }
  }
  generateMultipleBorderaux(query): any {
    return this.httpClient
      .post(environment.api.partnerMicroService + '/bordereau', query, {
        observe: 'response',
        responseType: 'arraybuffer',
      })
      .toPromise();
  }
  generateExcel(query): any {
    return this.httpClient
      .post(
        environment.api.partnerMicroService +
          '/deliveryRequest' +
          '/partner/filterStatus',
        query,
        {
          observe: 'response',
          responseType: 'arraybuffer',
        }
      )
      .toPromise();
  }
  generateExcelV2(query): any {
    return this.httpClient
      .post(
        environment.api.partnerMicroService +
          '/deliveryRequest' +
          '/partner/filterStatus/v2',
        query,
        {
          observe: 'response',
          responseType: 'arraybuffer',
        }
      )
      .toPromise();
  }

  generateDeliveryStatsInExcel(query): any {
    return this.httpClient
      .post(
        environment.api.partnerMicroService + '/stats/client/excel',
        query,
        {
          observe: 'response',
          responseType: 'arraybuffer',
        }
      )
      .toPromise();
  }

  getJobRequestHistory(query, populate): any {
    return this.httpClient
      .get(
        environment.api.partnerMicroService +
          '/jobRequestHistory' +
          '?sort=-createdAt&query=' +
          JSON.stringify(query) +
          '&populate=' +
          JSON.stringify(populate),
        { observe: 'response' }
      )
      .toPromise();
  }
  getJobRequestActionHistory(query, populate): any {
    return this.httpClient
      .get(
        environment.api.partnerMicroService +
          '/ActionsHistory?sort=-createdAt&query=' +
          JSON.stringify(query) +
          '&populate=' +
          JSON.stringify(populate)
      )
      .toPromise();
  }
  updateVisibility(id, body): any {
    return this.httpClient
      .put(environment.api.serverUrl + '/ActionsHistory/' + id, body)
      .toPromise();
  }

  getBusiness(business): any {
    return this.httpClient
      .get(environment.api.partnerMicroService + '/business' + '/' + business)
      .toPromise()
      .catch(this.handleError);
  }

  getMultiBusiness(queries): any {
    const params = new HttpParams({
      fromObject: queries,
    });
    return this.httpClient
      .get(environment.api.backendBase + '/business/paginate', { params })
      .toPromise()
      .catch(this.handleError);
  }

  updateOneBusiness(queries): any {
    const params = new HttpParams({
      fromObject: queries,
    });
    console.log('params:', params);
    return this.httpClient
      .put(environment.api.backendBase + '/business', queries)
      .toPromise()
      .catch(this.handleError);
  }

  updateBusiness(business): any {
    return this.httpClient
      .put(
        environment.api.partnerMicroService + '/business' + '/' + business._id,
        business
      )
      .toPromise()
      .catch(this.handleError);
  }
  updateApiKey(id): any {
    return this.httpClient
      .post(
        environment.api.partnerMicroService + '/business' + '/updateapikey',
        { id }
      )
      .toPromise();
  }

  sendInvitation(reqBody): any {
    return this.httpClient
      .post(environment.api.user + '/users/invitation/fromPartner', reqBody)
      .toPromise();
  }

  editCollaborator(reqBody): any {
    return this.httpClient
      .post(environment.api.user + '/users/collaborator/edit', reqBody)
      .toPromise();
  }

  getCollaborators(reqBody): any {
    return this.httpClient
      .post(environment.api.user + '/users/collaborators', reqBody)
      .toPromise();
  }

  private handleError(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response || error) {
      console.log(error);

      const body = error.json() || '';
      const err = JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Promise.reject(errMsg);
  }
}
